<template>
  <div class="Payment-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar
          v-if="Payment"
          :title="`Payment List`"
          :start="start"
          :end="end"
        />

        <v-container fluid>
          <v-alert class="mt-3" dense outlined type="info">
            <div class="d-flex justify-space-between align-center">
              <span class="font-weight-medium">Total</span>
              <span class="font-weight-bold">{{ total | currency }}</span>
            </div>
          </v-alert>
          <div v-for="(payment, index) in Payment" :key="index" class="mb-4">
            <v-card outlined>
              <v-toolbar dense class="mb-3" flat>
                <v-toolbar-title class="subtitle-1">
                  {{ payment.date | moment("MM/DD/YYYY") }} ({{
                    payment.paymentMethod
                  }})
                </v-toolbar-title>
                <v-spacer> </v-spacer>
                {{ payment.total | currency }}
              </v-toolbar>
              <v-card-text>
                <PaymentDetail
                  v-if="payment.PaymentDetails && payment.PaymentDetails.length"
                  :PaymentId="payment.id"
                ></PaymentDetail>
              </v-card-text>
            </v-card>
          </div>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
// import CategoryService from "@/modules/Category/service";
import paymentService from "@/modules/Customer/Payment/service";
const PaymentDetail = () =>
  import("@/modules/ReportView/GlobalReport/PaymentDetail.vue");
// import Hashids from "hashids";
// const hashids = new Hashids();

export default {
  data() {
    return {
      start: null,
      end: null,
      isLoading: true,
      Payment: [],
      headers: [
        { text: "", value: "data-table-expand", width: 60, sortable: false },
        {
          text: "DATE",
          align: "left",
          value: "name",
          sortable: true,
        },
        // {
        //   text: "CUSTOMER",
        //   align: "left",
        //   value: "payee",
        //   sortable: true,
        // },
        {
          text: "PAYMENT METHOD",
          align: "left",
          value: "note",
          sortable: true,
        },
        {
          text: "AMOUNT",
          align: "right",
          value: "amount",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    total() {
      let total = 0;
      this.Payment.map((row) => {
        total += row.total;
      });
      return total;
    },
  },
  async created() {
    this.start = this.$route.query.start;
    this.end = this.$route.query.end;
    await this.getAll();
  },
  components: {
    ReportViewBar,
    PaymentDetail,
  },
  methods: {
    getAll() {
      let where = {
        start: this.start,
        end: this.end,
      };

      return paymentService.getAll(where).then((response) => {
        console.log("response category", response);
        this.$Progress.finish();
        this.Payment = response.data;
        this.Payment.forEach((payment) => {
          payment.total = 0;
          (payment.PaymentDetails || []).forEach((d) => {
            payment.total += Number(d.amount || 0);
          });
        });
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
